
interface OptionChoice {
  option_id: string;
  title: string;
  description?: string;
  icon?: string;
}

interface OptionSelectorCardProps {
  data: {
    question: string;
    options: OptionChoice[];
    allow_multiple?: boolean;
  };
  onSelect: (selection: Record<string, unknown>) => void;
}

export function OptionSelectorCard({ data, onSelect }: OptionSelectorCardProps) {
  return (
    <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden my-2">
      <div className="p-3">
        <p className="text-sm font-medium text-gray-700 mb-2">{data.question}</p>
        <div className="space-y-1.5">
          {data.options.map((opt) => (
            <button
              key={opt.option_id}
              onClick={() => onSelect({ option_id: opt.option_id, title: opt.title })}
              className="w-full flex items-center gap-3 p-2.5 rounded-lg border border-gray-200 hover:border-primary-300 hover:bg-primary-50 transition-colors text-left"
            >
              {opt.icon && <span className="text-lg">{opt.icon}</span>}
              <div>
                <span className="text-sm font-medium text-gray-900">{opt.title}</span>
                {opt.description && (
                  <p className="text-xs text-gray-500 mt-0.5">{opt.description}</p>
                )}
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
